export const GET_QUESTIONS = 'Get_Questions';